interface Options {
	[key: string]: any
}

export const httpGet = async <T>(url: string, options: Options = {}): Promise<T> => {
	const response = await fetch(url, {
		...options,
		method: 'GET'
	})

	if (response.ok) {
		return response.json()
	}

	throw new Error(`${response.status}`)
}

export const httpPost = async (url: string, postData: Options = {}): Promise<Response> => {
	const response = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(postData)
	})

	if (response.ok) {
		return response
	}

	throw new Error(`${response.status}`)
}
